<main class="d-flex flex-column">
  <div class="d-flex flex-column">
    <label>Presença confirmada por:</label>
    <span>{{newAuthForm.name}}</span>
  </div>
  <div class="d-flex flex-column">
    <label>Organização/entidade representada*</label>
    <p-autoComplete
        [(ngModel)]="newAuthForm.organization"
        optionLabel="name" required
        [suggestions]="filteredOrganizations()"
        (completeMethod)="filterOrganization($event)"
        [disabled]="undoCredential"
    ></p-autoComplete>
  </div>
  <div class="d-flex flex-column">
    <label>Esta Organização/entidade será representada neste evento por:</label>
    <div class="d-flex flex-row">
      <p-radioButton (ngModelChange)="himselfSelected()"
                     [disabled]="undoCredential" value="himself" [(ngModel)]="newAuthForm.representing" inputId="reprHimself"/>
      <label for="reprHimself">{{newAuthForm.name}}</label>
    </div>
    <div class="d-flex flex-row">
      <p-radioButton (ngModelChange)="otherSelected()"
                     [disabled]="undoCredential" value="other" [(ngModel)]="newAuthForm.representing" inputId="reprOther"/>
      <label for="reprOther">Outra pessoa:</label>
    </div>
    <div class="reprInfo">
      <div class="row">
        <div class="col" >
          <label for="reprCpf" class="text-end" [ngClass]="newAuthForm.representing === 'other' ? '' : 'disabled'" >CPF*</label>
        </div>
      </div>
      <div class="row d-flex align-items-center my-2">

        <div class="col-7 px-1">
          <p-inputMask [disabled]="newAuthForm.representing !== 'other' || undoCredential" gambiCursorMask
             mask="999.999.999-99" [(ngModel)]="newAuthForm.authorityCpf" inputId="reprCpf" placeholder="000.000.000-00" />
        </div>
        <div class="col-2 px-1">
          <button [disabled]="newAuthForm.representing !== 'other' || undoCredential" (click)="loadAcInfo()">Procurar</button>
        </div>
      </div>
      <div class="row" [hidden]="!isOtherAndLooked">
        <div class="col">
          <label for="reprName" class="text-end" [ngClass]="newAuthForm.representing === 'other' ? '' : 'disabled'">Nome*</label>
        </div>
      </div>
      <div class="row align-items-center my-2" [ngClass]="isOtherAndLooked ? 'd-flex' : ''"  [hidden]="!isOtherAndLooked">
        <div class="col px-1">
          <input type="text" pInputText [disabled]="newAuthForm.representing !== 'other' || undoCredential"
             [(ngModel)]="newAuthForm.authorityRepresenting" id="reprName" class="w-100" required
             [readOnly]="fromAc.authorityRepresenting"/>
        </div>
      </div>
    </div>

  </div>
  <div class="flex-column" [hidden]="!isOtherAndLooked">
    <label for="reprRole">Cargo do Representante*</label>

    <input type="text" pInputText [(ngModel)]="newAuthForm.authorityRole"
      class="w-100" id="reprRole" required
           [disabled]="undoCredential"/>
  </div>
  <div class="flex-column" [ngClass]="isOtherAndLooked ? 'd-flex' : ''"  [hidden]="!isOtherAndLooked">
    <label for="municipio">Município do Representante*</label>
    <p-dropdown class="locality-dropbox" [options]="localities"
                [disabled]="undoCredential" required
        [(ngModel)]="newAuthForm.authorityLocalityId" field="label"
        optionLabel="name" optionValue="id" placeholder="Selecione o seu Município">
      </p-dropdown>
  </div>
  <div class="flex-column" [ngClass]="isOtherAndLooked ? 'd-flex' : ''"  [hidden]="!isOtherAndLooked">
    <label for="email">Email do Representante*</label>
    <input type="email" pInputText [(ngModel)]="newAuthForm.authorityEmail" #campoEmail="ngModel"
           [disabled]="undoCredential" required pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
      class="w-100" id="email" [readOnly]="fromAc.authorityEmail" />
  </div>
</main>
<footer class="px-2">
  <div class="d-flex gap-2">
    <button [disabled]="!isAuthValid" (click)="finishRegister()" class="align-self-start">Confirmar</button>
    <p-inputSwitch [(ngModel)]="undoCredential" ></p-inputSwitch>
    Descredenciar
  </div>
</footer>
